module.exports = __webpack_public_path__ + "img/materialize.c8d9f71a.png";